import React from 'react'
import { Link } from 'react-router-dom'
import { FaInfoCircle } from 'react-icons/fa'
import withConfig from '../../wrappers/withConfig'

const InfoButton = ({
    config,
    dashboardName,
    className = 'button is-info',
}) => {
    const { LAYOUT } = config || {}
    const layoutForDashboard = LAYOUT?.[dashboardName]
    const infoLink = layoutForDashboard?.INFO_LINK
    const text = layoutForDashboard?.TEXT

    return (
        infoLink && (
            <Link to={infoLink} target="_blank" className={className}>
                <div className="toggle">
                    <FaInfoCircle />
                    <div className="toggle">{text}</div>
                </div>
            </Link>
        )
    )
}

export default withConfig(InfoButton)
